import { TMdfBreakdownGroupField } from 'partner360/features/mdfActivities/model/types'

import type { TCockpitInitiativeGroupField } from './types'

interface IGroupOption<TValue> {
  value: TValue
  label: string
}

/** Group-by options of the Initiatives sub-tab, in the wireframe's order. */
export const COCKPIT_INITIATIVE_GROUP_OPTIONS: IGroupOption<TCockpitInitiativeGroupField>[] = [
  { value: 'development', label: 'BU Strategic Initiative' },
  { value: 'businessPriority', label: 'GTM Business Priority' },
  { value: 'category', label: 'Category' },
  { value: 'period', label: 'Period' },
  { value: 'status', label: 'Status' },
]

/** Group-by options of the MDF sub-tab. A subset of the MDF dashboard's own breakdown fields —
 *  `businessFocus` is left out, since it is filled on almost no allocation and would draw a
 *  chart of one bar and one `—`. */
export const COCKPIT_MDF_GROUP_OPTIONS: IGroupOption<TMdfBreakdownGroupField>[] = [
  { value: 'strategicInitiatives', label: 'Strategic Initiative' },
  { value: 'businessPriorities', label: 'GTM Business Priority' },
  { value: 'businessUnit', label: 'Business Unit' },
  { value: 'category', label: 'Category' },
  { value: 'activityType', label: 'Activity Type' },
  { value: 'timeframe', label: 'Timeframe' },
]
